import TenantsList from './TenantsList';
export default TenantsList;